module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-haircut-fr-FR@3x-26e9a553bdb4a9598714d86a6aa067d8.png";